(function() {
  'use strict';

  // 1. Reaction Persistence & Duplicate Protection via localStorage
  var pageKey = (document.querySelector('[data-final-offer]') && document.querySelector('[data-final-offer]').getAttribute('data-product-handle')) || window.location.pathname || 'adv';
  var STORAGE_KEY = 'adv_reactions_' + encodeURIComponent(pageKey);
  var userReactions = {};
  try {
    userReactions = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch(e) {}

  document.querySelectorAll('[data-reaction-btn]').forEach(function(btn) {
    var key = btn.getAttribute('data-reaction-key') || btn.getAttribute('data-reaction-btn');
    if (key && userReactions[key]) {
      btn.classList.add('is-active');
      var countEl = btn.querySelector('[data-reaction-count]');
      if (countEl) {
        var base = parseInt(countEl.textContent.trim(), 10) || 0;
        countEl.textContent = base + 1;
      }
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-reaction-btn]');
    if (!btn) return;
    var countEl = btn.querySelector('[data-reaction-count]');
    if (!countEl) return;
    var currentCount = parseInt(countEl.textContent.trim(), 10) || 0;
    var key = btn.getAttribute('data-reaction-key') || btn.getAttribute('data-reaction-btn');
    if (btn.classList.contains('is-active')) {
      btn.classList.remove('is-active');
      countEl.textContent = Math.max(0, currentCount - 1);
      delete userReactions[key];
    } else {
      btn.classList.add('is-active');
      countEl.textContent = currentCount + 1;
      userReactions[key] = 1;
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(userReactions));
    } catch(e) {}
  });

  // 2. Comments / Reviews Incremental Show More (reveals 2-3 items at a time)
  document.addEventListener('click', function(e) {
    var moreBtn = e.target.closest('[data-comments-more], [data-reviews-more]');
    if (!moreBtn) return;
    var container = moreBtn.closest('[data-comments]') || document.querySelector('[data-comments]');
    if (!container) return;

    var list = container.querySelector('[data-comments-list]') || container;
    // Find all hidden top-level comment items
    var hiddenComments = Array.from(list.children).filter(function(el) {
      return el.classList.contains('adv-v2-comment') && el.classList.contains('is-hidden');
    });

    var STEP = 3; // Reveal 2-3 comments per click
    var toReveal = hiddenComments.slice(0, STEP);

    toReveal.forEach(function(commentEl) {
      commentEl.classList.remove('is-hidden');
      // If this comment has an adjacent replies container, reveal it too
      var nextSibling = commentEl.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('adv-v2-comment__replies')) {
        nextSibling.classList.remove('is-hidden');
      }
    });

    // Check if any hidden comments remain
    var remainingHidden = Array.from(list.children).filter(function(el) {
      return el.classList.contains('adv-v2-comment') && el.classList.contains('is-hidden');
    });

    if (remainingHidden.length === 0) {
      var moreContainer = moreBtn.closest('[data-more-container]') || moreBtn;
      moreContainer.style.display = 'none';
    }
  });

  // 3. Countdown Timer Logic
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var daysEl = countdownEl.querySelector('[data-countdown-days]');
    var hoursEl = countdownEl.querySelector('[data-countdown-hours]');
    var minsEl = countdownEl.querySelector('[data-countdown-minutes]');
    var secsEl = countdownEl.querySelector('[data-countdown-seconds]');
    var expMsg = document.querySelector('[data-expired-message]');
    var behavior = countdownEl.getAttribute('data-expiration-behavior') || 'show_expired_message';
    var durationMinutes = parseInt(countdownEl.getAttribute('data-duration-minutes'), 10) || 30;
    var endDatetimeStr = countdownEl.getAttribute('data-end-datetime');
    
    var endTime;
    if (endDatetimeStr) {
      endTime = new Date(endDatetimeStr).getTime();
    } else {
      var sessionKey = 'adv_countdown_end_' + encodeURIComponent(pageKey);
      var cachedEnd = sessionStorage.getItem(sessionKey);
      if (cachedEnd && parseInt(cachedEnd, 10) > Date.now()) {
        endTime = parseInt(cachedEnd, 10);
      } else {
        endTime = Date.now() + durationMinutes * 60 * 1000;
        sessionStorage.setItem(sessionKey, endTime.toString());
      }
    }

    function updateTimer() {
      var now = Date.now();
      var remaining = Math.max(0, Math.floor((endTime - now) / 1000));
      
      if (remaining <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        if (behavior === 'show_expired_message' && expMsg) {
          expMsg.hidden = false;
        } else if (behavior === 'hide') {
          countdownEl.style.display = 'none';
        }
        return;
      }

      var d = Math.floor(remaining / 86400);
      var h = Math.floor((remaining % 86400) / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;

      if (daysEl) daysEl.textContent = d < 10 ? '0' + d : d.toString();
      if (hoursEl) hoursEl.textContent = h < 10 ? '0' + h : h.toString();
      if (minsEl) minsEl.textContent = m < 10 ? '0' + m : m.toString();
      if (secsEl) secsEl.textContent = s < 10 ? '0' + s : s.toString();
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // 4. Sticky CTA Trigger & Final Offer Visibility Engine
  function initStickyCTA() {
    var stickyBar = document.querySelector('[data-sticky-cta]');
    if (!stickyBar) return;

    var hasReveal = stickyBar.getAttribute('data-has-reveal') === 'true';
    var fallbackPercent = parseInt(stickyBar.getAttribute('data-fallback-percent'), 10) || 30;
    var hideFinalOffer = stickyBar.getAttribute('data-hide-final-offer') === 'true';
    var revealTarget = document.querySelector('[data-product-reveal]');
    var finalOfferSection = document.querySelector('[data-final-offer]');

    var triggered = false;

    function checkStickyState() {
      // 1. Check activation trigger
      if (!triggered) {
        if (hasReveal && revealTarget) {
          // Case A: PRODUCT_REVEAL exists -> activate when reader reaches/passes that section
          var rRect = revealTarget.getBoundingClientRect();
          var winH = window.innerHeight || document.documentElement.clientHeight || 800;
          if (rRect.top <= winH) {
            triggered = true;
          }
        } else {
          // Case B: No PRODUCT_REVEAL -> activate at fallback scroll percent (default 30%)
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          var docHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight
          ) - (window.innerHeight || document.documentElement.clientHeight || 800);
          if (docHeight > 0 && ((scrollTop / docHeight) * 100) >= fallbackPercent) {
            triggered = true;
          }
        }
      }

      // 2. Check Final Offer visibility
      var finalOfferInView = false;
      if (finalOfferSection && hideFinalOffer) {
        var foRect = finalOfferSection.getBoundingClientRect();
        var winH2 = window.innerHeight || document.documentElement.clientHeight || 800;
        finalOfferInView = (foRect.top <= winH2 && foRect.bottom >= 0);
      }

      // 3. Update visibility & apply inline styles for 100% rendering certainty
      if (triggered && !finalOfferInView) {
        stickyBar.classList.add('is-visible');
        stickyBar.style.transform = 'translateY(0)';
        stickyBar.style.opacity = '1';
        stickyBar.style.visibility = 'visible';
        stickyBar.style.display = 'block';
        stickyBar.style.pointerEvents = 'auto';
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.style.transform = 'translateY(120%)';
        stickyBar.style.opacity = '0';
        stickyBar.style.visibility = 'hidden';
        stickyBar.style.pointerEvents = 'none';
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', checkStickyState, { passive: true, capture: true });
    document.addEventListener('scroll', checkStickyState, { passive: true, capture: true });
    window.addEventListener('resize', checkStickyState, { passive: true });
    window.addEventListener('load', checkStickyState);
    document.addEventListener('DOMContentLoaded', checkStickyState);
    
    // Polling interval on initial load to handle dynamic layout and images
    var pollCount = 0;
    var intervalId = setInterval(function() {
      checkStickyState();
      pollCount++;
      if (pollCount > 15) clearInterval(intervalId);
    }, 250);

    checkStickyState();
  }

  // 5. Suppress Shopify Chat / Inbox on Advertorial Pages only
  function hideShopifyChat() {
    var selectors = [
      '#shopify-chat', 'iframe#ShopifyChat', '.shopify-chat',
      '#inbox-root', '#dummy-chat-button', 'shopify-chat',
      'iframe[name*="chat" i]', 'iframe[id*="chat" i]', 'iframe[id*="inbox" i]',
      '.chat-button-container', '[data-shopify-chat-button]'
    ];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStickyCTA();
      hideShopifyChat();
    });
  } else {
    initStickyCTA();
    hideShopifyChat();
  }

  window.addEventListener('load', hideShopifyChat);
  var chatPollCount = 0;
  var chatPoll = setInterval(function() {
    hideShopifyChat();
    chatPollCount++;
    if (chatPollCount > 20) clearInterval(chatPoll);
  }, 500);
})();